import { ApplicationConfig, ErrorHandler, provideAppInitializer, inject } from '@angular/core';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi, withFetch, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideStore } from '@ngrx/store';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { provideMarkdown } from 'ngx-markdown';
import * as Sentry from '@sentry/angular';
import { routes } from './app.routes';
import { CustomRouteReuseStrategy } from './router-strategy';
import { AuthInterceptor } from './security/auth.interceptor';
import { liveMapReducer } from './pages/live-map/store/live-map.reducer';
import { Amplify } from 'aws-amplify';
import { environment } from '../environments/environment';

const initializeApp = () => {
  return async (): Promise<any> => {
    Amplify.configure({
      Auth: {
        Cognito: {
          userPoolClientId: environment.authentication.clientId,
          userPoolId: environment.authentication.userPoolId,
          userPoolEndpoint: !!environment.authentication.endpoint ? environment.authentication.endpoint : undefined,
          signUpVerificationMethod: 'code',
          mfa: {
            status: 'optional',
          },
        }
      }
    });
  };
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideStore({ ui: liveMapReducer }),
    provideMarkdown(),
    provideMomentDateAdapter(),
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [],
    },
    provideAppInitializer(() => {
      const initializerFn = initializeApp();
      return initializerFn();
    }),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline' },
    },
    {
      provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
      useValue: { useUtc: true },
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: RouteReuseStrategy,
      useClass: CustomRouteReuseStrategy,
    },
    {
      provide: 'googleTagManagerId',
      useValue: 'GTM-TJZF5SCB',
    },
  ],
};
